import React from 'react';
import { cn } from '../lib/utils';
export const Spinner = ({ className }) => {
    return (React.createElement("div", { "aria-live": "polite", className: "relative size-8" },
        React.createElement("div", { className: cn('absolute size-8 inset-0 rounded-full animate-spin before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-5 before:h-5 before:bg-white before:rounded-full after:absolute after:top-1/2 after:right-0 after:-translate-y-1/2 after:w-1.5 after:h-1.5 after:bg-brand-navy after:rounded-full', className), style: {
                background: 'conic-gradient(from 90deg at 50% 50%, rgba(39, 174, 96, 0) 0deg, rgba(31, 144, 255, 0) 0.04deg, #0B2240 360deg)',
            } }),
        React.createElement("span", { className: "sr-only" }, "Loading...")));
};
